import { configureStore } from "@reduxjs/toolkit";
import contactReducer from '../features/contact/contactSlice';
import bookingReducer from "../features/booking/bookingSlice";
  

export const store = configureStore({
  reducer: {
 
    contact:contactReducer,
    
    booking:bookingReducer,
  
    
  },
});